import getSweepRulesService from '../services/getSweepRulesService';
import store from '../store/store';
import { ObservableMap } from 'mobx';
import EwsSweepRule from 'owa-service/lib/contract/EwsSweepRule';
import GetSweepRulesResponseMessage from 'owa-service/lib/contract/GetSweepRulesResponseMessage';
import { action } from 'satcheljs/lib/legacy';
import SweepRuleRequestStatus from '../store/schema/SweepRuleRequestStatus';
import setSweepRuleRequestStatus from 'owa-sweep-rules-option/lib/actions/setSweepRuleRequestStatus';
import { logUsage } from 'owa-analytics';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';

/**
 * Gets sweep rules and stores them in the sweepRules options store
 */
export default action('getSweepRules')(function getSweepRules() {
    store.sweepRuleIds = [];
    store.sweepRules = new ObservableMap();
    setSweepRuleRequestStatus(SweepRuleRequestStatus.Pending);

    return getSweepRulesService()
        .then(response => {
            const sweepResponseMessage = response.Body.ResponseMessages
                .Items[0] as GetSweepRulesResponseMessage;
            if (sweepResponseMessage.ResponseClass === 'Success') {
                const sweepRuleCollection = sweepResponseMessage.SweepRulesForUser;

                for (let sweepRule of sweepRuleCollection) {
                    const ewsSweepRule = sweepRule;
                    addSweepRuleToStore(ewsSweepRule);
                }
                logUsage('TnS_NumSweepRules', [sweepRuleCollection.length]);

                store.hasLoggedGetSweepRulesInformation = true;
                setSweepRuleRequestStatus(SweepRuleRequestStatus.Complete);
            } else {
                setSweepRuleRequestStatus(SweepRuleRequestStatus.Error);
            }
            return true;
        })
        .catch(error => {
            setSweepRuleRequestStatus(SweepRuleRequestStatus.Error);
            return true;
        });
});

let addSweepRuleToStore = action('addSweepRuleToStore')(function addSweepRuleToStore(
    sweepRule: EwsSweepRule
) {
    const ruleId = sweepRule.RuleId;
    if (!store.hasLoggedGetSweepRulesInformation) {
        logUsage('TnS_SweepRuleInformation', [
            folderIdToName(sweepRule.SweepConditions[0].SourceFolderId),
            folderIdToName(sweepRule.SweepActions[0].DestinationFolderId),
            sweepRule.SweepActions[0].CleanUpType,
            sweepRule.SweepActions[0].KeepCount,
        ]);
    }

    store.sweepRuleIds.push(ruleId);
    store.sweepRules.set(ruleId, {
        ...sweepRule,
    } as EwsSweepRule);
});
